import { useDonation } from '../context/DonationContext'
import { formatCurrency } from '../utils/formatCurrency'
import { Donation } from '../types'

export default function IndividualDonations() {
  const { 
    state: { filteredDonations, currentSort },
    setCurrentSort 
  } = useDonation()

  const toggleSort = (column: string) => {
    if (currentSort.column === column) {
      setCurrentSort({ ...currentSort, order: currentSort.order === 'asc' ? 'desc' : 'asc' })
    } else {
      setCurrentSort({ column, order: 'asc' })
    }
  }

  const getSortIcon = (column: string) => {
    if (currentSort.column === column) {
      return currentSort.order === 'asc' ? '▲' : '▼'
    }
    return ''
  }

  // Ensure filteredDonations is an array before sorting
  const sortedDonations = Array.isArray(filteredDonations) 
    ? [...filteredDonations].sort((a, b) => {
        let valueA, valueB;
        
        if (currentSort.column === 'Amount') {
          valueA = parseFloat(a[currentSort.column as keyof Donation] as string)
          valueB = parseFloat(b[currentSort.column as keyof Donation] as string)
        } else if (currentSort.column === 'Created at') {
          valueA = new Date(a[currentSort.column as keyof Donation] as string)
          valueB = new Date(b[currentSort.column as keyof Donation] as string)
        } else {
          valueA = a[currentSort.column as keyof Donation] ?? ''
          valueB = b[currentSort.column as keyof Donation] ?? ''
        }

        if (valueA < valueB) return currentSort.order === 'asc' ? -1 : 1
        if (valueA > valueB) return currentSort.order === 'asc' ? 1 : -1
        return 0
      })
    : []

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Index</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => toggleSort('Created at')}>
              Date {getSortIcon('Created at')}
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => toggleSort('Name')}>
              Name {getSortIcon('Name')}
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => toggleSort('Email')}>
              Email {getSortIcon('Email')}
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => toggleSort('Country')}>
              Country {getSortIcon('Country')}
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer" onClick={() => toggleSort('Amount')}>
              Amount {getSortIcon('Amount')}
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {sortedDonations.map((donation, index) => (
            <tr key={`${donation.Email}-${donation['Created at']}-${index}`} id={`donation-${index}`}>
              <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
              <td className="px-6 py-4 whitespace-nowrap">
                {new Date(donation['Created at']).toLocaleDateString()} {new Date(donation['Created at']).toLocaleTimeString()}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">{donation.Name}</td>
              <td className="px-6 py-4 whitespace-nowrap">{donation.Email}</td>
              <td className="px-6 py-4 whitespace-nowrap">{donation.Country || '-'}</td>
              <td className="px-6 py-4 whitespace-nowrap">{formatCurrency(parseFloat(donation.Amount))}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

